
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()

    export class PsTaxInvoiceHdDialog extends Serenity.EntityDialog<PsTaxInvoiceHdRow, any> {
        protected getFormKey() { return PsTaxInvoiceHdForm.formKey; }
        protected getIdProperty() { return PsTaxInvoiceHdRow.idProperty; }
        protected getLocalTextPrefix() { return PsTaxInvoiceHdRow.localTextPrefix; }
        protected getNameProperty() { return PsTaxInvoiceHdRow.nameProperty; }
        protected getService() { return PsTaxInvoiceHdService.baseUrl; }
        protected getDeletePermission() { return PsTaxInvoiceHdRow.deletePermission; }
        protected getInsertPermission() { return PsTaxInvoiceHdRow.insertPermission; }
        protected getUpdatePermission() { return PsTaxInvoiceHdRow.updatePermission; }

        protected form = new PsTaxInvoiceHdForm(this.idPrefix);
        public hide: number;
        public waning: boolean;
        private Docno: string;

        constructor() {
            super();
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");

                
            });

            this.form.CusTaxTypeFg.changeSelect2(async e => {
                // let RefDocNo = Q.toId(this.form.RefDocNo.value)
                this.RequestfieldbyType();
            });

            this.form.TaxInvNameId.change(async e => {
                let taxname = Q.toId(this.form.TaxInvNameId.value)
                if (taxname != null) {

                    let add = Q.tryFirst(PsTaxInvoiceAddressRow.getLookup().items, x => x.Id == taxname)

                    if (add != null) {

                        this.form.TaxInvNameId.value = String(add.Id || "")
                        this.form.CusTaxTypeFg.value = String(add.CusTaxTypeFg || "")
                        this.form.TaxInvName.value = String(add.TaxInvName || "");
                        this.form.TaxId.value = String(add.TaxId || "");
                        this.form.TelNo.value = String(add.TelNo || "");
                        this.form.TaxEmail.value = String(add.TaxEmail || "");
                        this.form.TaxBranchName.value = String(add.TaxBranchName || "");
                        this.form.TaxBranchNo.value = String(add.TaxBranchNo || "");
                        this.form.TaxInvAddressLine1.value = String(add.TaxInvAddressLine1 || "");
                        this.form.TaxInvAddressLine2.value = String(add.TaxInvAddressLine2 || "");
                        this.form.TaxInvAddressLine3.value = String(add.TaxInvAddressLine3 || "");
                        this.form.TaxPostalCode.value = String(add.TaxPostalCode || "");
                        this.form.TaxCountryCode.value = String(add.TaxCountryCode || "");
                        this.RequestfieldbyType()
                    }

                } else {

                }
            });

            this.form.RefDocNo.changeSelect2(async e => {
                // let RefDocNo = Q.toId(this.form.RefDocNo.value)
                this.cleardata()
            });


        }

        private calcDataOnGrid() {
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;

                for (var i of this.form.DtList.getItems()) {
                    totalAmt += i.ItemNetSales2 || 0;
                    VatAmt += i.ItemVatAmt2 || 0;

                }

               var vatdiff = VatAmt - this.form.VatAmt.value

               if(vatdiff != 0){
                // var a = this.form.DtList.getItems().map(o => o.LineItemNo)
                var a = this.form.DtList.getItems().filter(o => o.VatType == "V");

                var lineItemNos = a.map(o => o.LineItemNo);

                console.log(a)
                console.log(a.length)
                if (a.length > 0) {
                    // var maxLineItemNo = Math.max(...lineItemNos) : 0;
                    var maxLineItemNo = Math.max.apply(Math, lineItemNos.map(function (o) { return o; })) || 0

                    // b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0
// 
                    console.log("change" + maxLineItemNo +" diff: "+vatdiff)
                    this.form.DtList.lastV = maxLineItemNo;                   

                    // this.form.DtList.totalsdiff = vatdiff
                } else {

                }
             }

            });

            (this.form.DtList.view as any).onRowCountChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;

                for (var i of this.form.DtList.getItems()) {
                    totalAmt += i.ItemNetSales2 || 0;
                    VatAmt += i.ItemVatAmt2 || 0;

                }

                var vatdiff = VatAmt - this.form.VatAmt.value

                if(vatdiff != 0){
                 // var a = this.form.DtList.getItems().map(o => o.LineItemNo)
                 var a = this.form.DtList.getItems().filter(o => o.VatType == "V");
 
                 var lineItemNos = a.map(o => o.LineItemNo);
 
                 console.log(a)
                 console.log(a.length)
                 if (a.length > 0) {
                     // var maxLineItemNo = Math.max(...lineItemNos) : 0;
                     var maxLineItemNo = Math.max.apply(Math, lineItemNos.map(function (o) { return o; })) || 0
 
                     // b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0
 // 
                     console.log("change" + maxLineItemNo +" diff: "+vatdiff)
                     this.form.DtList.lastV = maxLineItemNo;                   
 
                    //  this.form.DtList.totalsdiff = vatdiff
                } else {

                }
             }

            });

        }

        private cleardata() {
            this.form.TaxInvName.value = null;
            this.form.TaxId.value = null;
            this.form.TaxInvAddressLine1.value = null;
            this.form.TaxInvAddressLine2.value = null;
            this.form.TaxInvAddressLine3.value = null;
            this.form.TelNo.value = null;
            this.form.TaxInvNameId.value = null;
            this.form.MbId.value = null;

            this.form.GrossAmt.value = null;
            this.form.DiscountAmt.value = null;
            this.form.ChargeAmt.value = null;
            this.form.SumDisChargeAmt.value = null;
            this.form.NetAmt.value = null;
            this.form.NetSalesNonVat.value = null;
            this.form.NetSalesExVat.value = null;
            this.form.NetSalesNormal.value = null;
            this.form.VatAmt.value = null;
            this.form.TaxInvoiceAmt.value = null;
            this.form.RefTaxInvoiceAmt.value = null;
            this.form.NewTaxInvoiceAmt.value = null;
            this.form.TaxInvoiceAmtDiff.value = null;
        }



        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();


            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            // if(!this.isNew())    {
            let send: Serenity.ToolButton =
            {
                title: "CONFRIM",
                hint: "confrim save",
                separator: false,
                cssClass: "button-confrim",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: (e) => {

                    var self = this;

                    
                    // let m:string = this.form.RefDocNo.value
                    // console.log(m)
                    // var x = Q.tryFirst(PsTaxInvoiceHdRow.getLookup().items, x => x.RefDocNo == m) ?? null;
                    // if (x != null) {
                    //     this.waning = true
                    //     Q.warning("ได้มีการบันทึก เอกสารรับเข้า เลขที่นี้ใน IR ใบอื่่นก่อนแล้ว")
                    // }
                    var a = this.form.DtList.getItems()
                    if(a.length > 0){

                    if (this.waning == true ) {

                    } else {

                        if (Q.isEmptyOrNull(this.form.DocNo.value)) {
                            this.getNextNumber();
                        }

                       

                        // this.disamtalocate()


                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    var a = this.loadById(id1);
                                }
                                else {
                                    var a = this.loadById(response.EntityId);
                                }

                                Q.confirm('ยืนยันส่งอนุมัติเอกสาร'
                                    , () => {
                                        this.form.PostFg.value = "1";


                                        var options = this.getSaveOptions((respons2) => {

                                            if (this.isEditMode()) {
                                                var id1 = respons2.EntityId;
                                                if (id1 == null) {
                                                    id1 = this.get_entityId();
                                                }
                                                this.loadById(id1);
                                            }
                                            else {
                                                this.loadById(respons2.EntityId);
                                                // this.dialogClose();
                                            }

                                            this.showSaveSuccessMessage(respons2);


                                        });



                                        options.onError = function (respons2) {
                                            Q.alert(respons2.Error.Message);
                                        }

                                        Q.serviceCall(options);




                                    });


                            });

                            options.onError = function (response) {
                                Q.alert(response.Error.Message);
                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                    }else{
                    Q.warning("ยังไม่ดึงข้อมูลรายการสินค้า")
                }
                }
            };
            buttons.push(send);
            // }

            let newSaveBtn: Serenity.ToolButton =
            {
                title: "SAVE",
                hint: "Save",
                separator: false,
                cssClass: "button-save",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: (e) => {

                    var self = this;
                    this.getNextNumber();
                    this.form.PostFg.value = "0";
                    // let m:string = this.form.RefDocNo.value
                    // console.log(m)
                    // var x = Q.tryFirst(PsTaxInvoiceHdRow.getLookup().items, x => x.RefDocNo == m) ?? null;
                    // if (x != null) {
                    //     this.waning = true
                    //     Q.warning("ได้มีการบันทึก เอกสารรับเข้า เลขที่นี้ใน IR ใบอื่่นก่อนแล้ว")
                    // }
                    var a = this.form.DtList.getItems()
                    if(a.length > 0){
                    if (this.waning == true) {

                    } else {


                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    this.loadById(id1);
                                }
                                else {
                                    if (this.isNew()) {
                                        this.dialogClose();
                                    } else {
                                        this.loadById(response.EntityId);

                                    }
                                }

                                this.showSaveSuccessMessage(response);


                            });

                            options.onError = function (response) {
                                if (response.Error.Message.includes("Can't save record. There is another record")) {
                                    Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                                    var s = self.form.DocNo.value
                                    var f = s.substring(0, 9)
                                    GeniuzPOS.PosShift.PsTaxInvoiceHdService.GetNextNumber({
                                        Prefix: f,
                                        Length: 16
                                    }, response => {

                                        self.form.DocNo.value = response.Serial;

                                    });
                                } else { Q.alert(response.Error.Message); }



                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                    }else{
                        Q.warning("ยังไม่ดึงข้อมูลรายการสินค้า")
                    }
                }
            };
            buttons.push(newSaveBtn);



            let newDeleteBtn: Serenity.ToolButton =
            {
                title: "ลบเอกสาร'",
                hint: "Delete",
                separator: false,
                cssClass: "delete-button",
                icon: "fa fa-save",
                hotkey: 'alt+x',
                onClick: (e) => {
                    Q.confirm('ยืนยันการลบเอกสาร', () => {
                        // this.doDelete(() => {

                        //     this.dialogClose();
                        // });
                        this.form.CancelFg.value = "2";
                        this.save((response) => {
                            this.dialogClose();
                        });

                    });
                }
            };
            buttons.push(newDeleteBtn);




            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );


            let CallPR: Serenity.ToolButton =
            {
                title: "",
                hint: "call Receipt",
                cssClass: "call",
                icon: "fa fa-level-down-alt",

                onClick: (e) => {

                    let doc = this.form.RefDocNo.value

                    if (!Q.isEmptyOrNull(doc)) {


                        var id = Q.tryFirst(GeniuzPOS.PosShift.PosTranHdRow.getLookup().items, x => x.DocNo == doc).DocNo;

                        PosTranHdService.Retrieve(
                            {
                                EntityId: id
                            }, response => {
                                this.setHdDetails(response.Entity);
                                console.log("before dtadd")
                                this.form.DtList.CallPR = this.form.RefDocNo.value;
                                this.checkcolumn();
                                this.getNextNumber();
                                // this.calcDataOnGrid()
                                // this.form.RefTaxInvoice.value = P.DocNo;
                                // this.form.RefTaxInvoiceDate.value = P.DocDate;
                            }
                        )


                    }

                }
            };
            buttons.push(CallPR);
            // if(!this.isNew()){

            if (!this.isNew()) {
                buttons.push(
                    {
                        title: Q.text("PDf"), // *** Get button text from translation
                        cssClass: '.panel-pdf',
                        icon: 'fa fa-file-pdf-o text-red',
                        onClick: () => {
                            //var row = this.view.getRows();                        
                            // this.save((response) => {


                            // const self = this;
                            // var request = self as PoPurOrderPrintData;
                            const request: PsTaxInvoicePrintData = {} as any; // สร้าง object ใหม่แทนการ cast

                            request.DocNo = this.form.DocNo.value
                            request.Header = Q.tryFirst(PsTaxInvoiceHdRow.getLookup().items, x => x.DocNo == this.form.DocNo.value)
                            let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                            if (fg != null) {
                                let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.form.ShopId.value)
                                request.BizName = s.ShopRegName
                                request.BizAddressLine1 = s.ShopRegAddressLine1
                                request.BizAddressLine2 = s.ShopRegAddressLine2
                                request.BizAddressLine3 = s.ShopRegAddressLine3
                                request.TaxId = s.ShopTaxId
                            } else {

                                let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                                request.BizName = q.BizName
                                request.BizAddressLine1 = q.TaxInvAddrLine1
                                request.BizAddressLine2 = q.TaxInvAddrLine2
                                request.BizAddressLine3 = q.TaxInvAddrLine3
                                request.TaxId = q.BizName
                            }

                            let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)
                            let sss = p.ShopLogoOnFrontScreen
                            if (!Q.isEmptyOrNull(sss)) {
                                let vp = window.location.href.replace("#", "").replace("#", "")
                                console.log(vp)
                                let ap = vp.replace("/PosShift/PsTaxInvoiceHd", "")
                                request.URLpic = ap + "/upload/" + p.ShopLogoOnFrontScreen
                            } else {
                                request.URLpic = "SARAPADTHAIENG.png" //wwwroot\Content\site\images\SARAPADTHAIENG.png


                            }

                            Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })


                        },

                    }
                );

            }

            let Editaddress: Serenity.ToolButton =
            {
                title: "Hide/Show address'",
                hint: "Edit address",
                separator: false,
                cssClass: "bt-editaddress",
                // icon: "fa fa-save",
                // hotkey: 'alt+x',
                onClick: (e) => {
                    if (this.hide == 1) {
                        this.hideadd(0);
                    } else {
                        this.hideadd(1);
                    }

                }
            };
            buttons.push(Editaddress);
            // }

            return buttons;

        }


        private hideadd(hided: number) {
            if (hided == 1) {
                this.form.CusTaxTypeFg.getGridField().toggle(false);
                this.form.TaxInvName.getGridField().toggle(false);
                this.form.TaxId.getGridField().toggle(false);
                this.form.TelNo.getGridField().toggle(false);
                this.form.TaxEmail.getGridField().toggle(false);
                this.form.TaxBranchName.getGridField().toggle(false);
                this.form.TaxBranchNo.getGridField().toggle(false);
                this.form.TaxInvAddressLine1.getGridField().toggle(false);
                this.form.TaxInvAddressLine2.getGridField().toggle(false);
                this.form.TaxInvAddressLine3.getGridField().toggle(false);
                this.form.TaxPostalCode.getGridField().toggle(false);
                this.form.TaxCountryCode.getGridField().toggle(false);
                this.hide = 1
            } else {
                this.form.CusTaxTypeFg.getGridField().toggle(true);
                this.form.TaxInvName.getGridField().toggle(true);
                this.form.TaxId.getGridField().toggle(true);
                this.form.TaxEmail.getGridField().toggle(true);
                this.form.TaxBranchName.getGridField().toggle(true);
                this.form.TaxBranchNo.getGridField().toggle(true);
                this.form.TaxInvAddressLine1.getGridField().toggle(true);
                this.form.TaxInvAddressLine2.getGridField().toggle(true);
                this.form.TaxInvAddressLine3.getGridField().toggle(true);
                this.form.TaxPostalCode.getGridField().toggle(true);
                this.form.TaxCountryCode.getGridField().toggle(true);
                this.hide = 0
            }
        }
        public setHdDetails(details: PosTranHdRow) {
            //hd

            this.form.RefDocDate.value = String(details.DocDate ?? "");


            let mbid = String(details.MbId ?? "");
            if (mbid.length > 0) {
                this.form.MbId.value = mbid
                let p = Q.tryFirst(Member.LookupMemberRow.getLookup().items, x => x.MbId == mbid)
                if (p != null) {
                    console.log(p)
                    let add = Q.tryFirst(PsTaxInvoiceAddressRow.getLookup().items, x => x.MbId == mbid)
                    if (add == null) {
                        // var id1: number =0
                        // let name = p.MbNameT.replace(/[*+]/g, "");
                        // console.log(name)
                        // var Id: PsTaxInvoiceAddressRow;
                        // Id.TaxInvName = name ?? "name";
                        // Id.TaxInvAddressLine1 = p.MbLineAddr1 ?? "";
                        // Id.TaxInvAddressLine2 = String(p.MbLineAddr2 ?? "");
                        // Id.TaxInvAddressLine3 = String(p.MbLineAddr3 ?? "");
                        // Id.TaxId = String(p.MbPid ?? "");
                        // Id.TelNo = String(p.MbTelNo ?? "");
                        // Id.MbId = mbid ?? "";

                        // PsTaxInvoiceAddressService.Create({
                        //     Entity: Id,

                        // });

                        // var Id: PsTaxInvoiceAddressRow = {
                        //     TaxInvName: name || "name",
                        //     TaxInvAddressLine1: p.MbLineAddr1 || "",
                        //     TaxInvAddressLine2: p.MbLineAddr2 || "",
                        //     TaxInvAddressLine3: p.MbLineAddr3 || "",
                        //     TaxId: p.MbPid || "",
                        //     TelNo: p.MbTelNo || "",
                        //     MbId: mbid || ""
                        // };

                        // PsTaxInvoiceAddressService.Create({
                        //     Entity: Id,

                        // }).then((response) => {
                        //     id1 = response.EntityId;
                        // });

                        // if (this.validateForm() && this.validateBeforeSave()) {
                        //     var options = this.getSaveOptions((response) => {

                        //         if (this.isEditMode()) {
                        //             var id1 = response.EntityId;
                        //             if (id1 == null) {
                        //                 id1 = this.get_entityId();
                        //             }
                        //             this.loadById(id1);
                        //         }
                        //         else {
                        //             if (this.isNew()) {
                        //                 this.dialogClose();
                        //             } else {
                        //                 this.loadById(response.EntityId);

                        //             }
                        //         }

                        //         this.showSaveSuccessMessage(response);


                        //     });

                        // console.log(id1)
                        Q.warning("Member นี้ ยังไม่ถูกเพิ่มที่อยู่ใบกำกับภาษี")
                        // Q.reloadLookup(LookupPostranhdsaleRow.lookupKey)

                        // this.form.TaxInvNameId.items.filter(x => Q.toId(x.StockTo) == this.myId)
                        // this.form.TaxInvNameId.updateItems();

                        // if (this.form.TaxInvNameId.items && this.form.TaxInvNameId.items.length > 0) {
                        //     Serenity.EditorUtils.setValue(this.form.TaxInvNameId, this.form.TaxInvNameId.items[0].id);
                        // }

                        // add = Q.tryFirst(PsTaxInvoiceAddressRow.getLookup().items, x => x.Id == id1)
                    }
                    else {
                        console.log(add)

                        this.form.TaxInvNameId.value = String(add.Id || "")
                        this.form.CusTaxTypeFg.value = String(add.CusTaxTypeFg || "")
                        this.form.TaxInvName.value = String(add.TaxInvName || "");
                        this.form.TaxId.value = String(add.TaxId || "");
                        this.form.TelNo.value = String(add.TelNo || "");
                        this.form.TaxEmail.value = String(add.TaxEmail || "");
                        this.form.TaxBranchName.value = String(add.TaxBranchName || "");
                        this.form.TaxBranchNo.value = String(add.TaxBranchNo || "");
                        this.form.TaxInvAddressLine1.value = String(add.TaxInvAddressLine1 || "");
                        this.form.TaxInvAddressLine2.value = String(add.TaxInvAddressLine2 || "");
                        this.form.TaxInvAddressLine3.value = String(add.TaxInvAddressLine3 || "");
                        this.form.TaxPostalCode.value = String(add.TaxPostalCode || "");
                        this.form.TaxCountryCode.value = String(add.TaxCountryCode || "");
                        this.RequestfieldbyType()

                    }

                }
            } else {

            }



            let salevat = String(details.SalesVatType ?? 'I');
            this.form.SalesVatType.value = salevat

            this.form.GrossAmt.value = (details.GrossSales ?? 0) - (details.AllItemDiscount ?? 0) + (details.AllItemCharge ?? 0);
            this.form.DiscountAmt.value = (details.BillDiscount ?? 0);
            this.form.ChargeAmt.value = (details.BillCharge || 0);
            this.form.SumDisChargeAmt.value =  (details.BillDiscount ?? 0) - (details.BillCharge ?? 0);
            console.log(details.GrossSales + "dis"+details.AllItemDiscount + "chardt"+details.AllItemCharge +"bill"+details.BillDiscount+"billchr"+details.BillCharge )
            this.form.NetAmt.value = details.DocAmt ?? 0;

            this.form.NetSalesNonVat.value = details.NetSalesNonVat ?? 0;
            this.form.NetSalesExVat.value = details.NetSalesExVat || 0;
            this.form.NetSalesNormal.value = details.NetSalesNormal ?? 0;

            this.form.VatAmt.value = details.VatOfNetSales ?? 0;


            if (salevat == "I") {
                this.form.TaxInvoiceAmt.value = this.form.NetAmt.value;
                this.form.DtList.round = Math.round((this.form.NetAmt.value - this.form.VatAmt.value) * 100) / 100
            } else {
                this.form.TaxInvoiceAmt.value = this.form.NetAmt.value + this.form.VatAmt.value;
                this.form.DtList.round = Math.round((this.form.NetAmt.value) * 100) / 100
            }

            this.form.DtList.vathd = Math.round(this.form.VatAmt.value * 100) / 100


            // let fac = details.Factor ?? 1;
            // if (fac == -1) {
            //     this.form.DocType.value = "2"
            //     let oldrecipt = details.RefDocNo ?? null;
            //     if(!Q.isEmptyOrNull(oldrecipt)){
            //         let f = Q.tryFirst(PsTaxInvoiceHdRow.getLookup().items, x => x.RefDocNo == oldrecipt)
            //         if(f != null){
            //             this.form.RefTaxInvoiceAmt.value = f.TaxInvoiceAmt ?? 0;
            //             this.form.NewTaxInvoiceAmt.value = f.TaxInvoiceAmt-this.form.TaxInvoiceAmt.value;
            //             this.form.TaxInvoiceAmtDiff.value = this.form.TaxInvoiceAmt.value;
            //         }else{
            //             Q.warning("เลขที่ใบกำกับอย่างย่อนี้ ("+oldrecipt+") ไม่ได้ถูกออกใบกำกับภาษีมาก่อน ")
            //         }
            //     }else{
            //         Q.warning("เลขที่ใบรับคืนนี้ ("+this.form.RefDocNo.value+") ไม่มีเลขอ้างอิงใบเสร็จขาย โปรดตรวจสอบ")
            //     }


            // } else {
            this.form.DocType.value = "1"

            this.form.RefTaxInvoiceAmt.value = 0;
            this.form.NewTaxInvoiceAmt.value = 0;
            this.form.TaxInvoiceAmtDiff.value = 0;
            // }




        }




        private checkcolumn() {
            let doc = this.form.DocType.value;
            let vat = this.form.SalesVatType.value;

            if (doc == "2") {
                if (vat == "E") {
                    this.CNvatext();
                } else {
                    this.CNvatIn();
                }
            } else {
                if (vat == "E") {
                    this.Taxvatext();
                } else {
                    this.TaxvatIn();
                }
            }
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.waning = false;
            this.hideadd(1);
            this.form.DtList.myPassValue = this.form.DocNo.value
            this.form.DtList.doctype = Number(this.form.DocType.value)
            this.form.DtList.salevattype = this.form.SalesVatType.value


            if (this.isNew()) {
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);
                this.form.ShopId.value = userId.ShopId
                this.form.DtList.shopid = userId.ShopId
                this.toolbar.findButton('delete-button').hide();
                this.form.RefDocNo.element.toggleClass("required", true);
                this.RequestfieldbyType()

            }

            this.toolbar.findButton('call').insertAfter(this.form.RefDocNo.element)



            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();
            if (this.entity.PostFg == 1 || this.entity.CancelFg == 1) {
                this.Readonlyafterapp();
                // this.form.DtList.Appfg = true


            }

        }

        private Readonlyafterapp() {

            Serenity.EditorUtils.setReadOnly(this.form.DocType, true);
            Serenity.EditorUtils.setReadOnly(this.form.DocNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShopId, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.ConcatRefDocNo1, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.MbId, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxInvNameId, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusTaxTypeFg, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxInvName, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxId, true);
            Serenity.EditorUtils.setReadOnly(this.form.TelNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxEmail, true);
            Serenity.EditorUtils.setReadOnly(this.form.SalesVatType, true);

            Serenity.EditorUtils.setReadOnly(this.form.TaxBranchName, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxBranchNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxInvAddressLine1, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxInvAddressLine2, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxInvAddressLine3, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxPostalCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxCountryCode, true);

            Serenity.EditorUtils.setReadOnly(this.form.DtList, true);
            Serenity.EditorUtils.setReadOnly(this.form.Remark, true);


            this.toolbar.findButton('apply-changes-button').hide();
            this.toolbar.findButton('save-and-close-button').hide();
            this.toolbar.findButton('delete-button').hide();
            this.toolbar.findButton('button-confrim').hide();
            this.toolbar.findButton('button-save').hide();


        }




        private getNextNumber() {
            var val = Q.trimToNull(this.form.DocNo.value);



            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                // console.log('User Id : ' + userId.ShopId);

                // this.form.ShopId.value = userId.ShopId
                try {
                    var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                    if (userRole != null) {
                        myRow = userRole.RoleId;
                    }
                    if (userRole != null || userRole.RoleId.valueOf) {
                        myRow = userRole.RoleId;
                    }
                    if (myRow == 1) {
                        //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                    }
                } catch {

                }

                var y = someDate.getFullYear();
                // var mo = "";
                // var ddd = "";

                // if (mm < 10) {
                //     mo = '0' + mm;

                // } else {
                //     mo = mm.toString();
                // }

                // if (dd < 10) {
                //     //ddd = '0' + dd;
                //     ddd = '';

                // } else {
                //     //ddd = dd.toString();
                //     ddd = '';
                // }

                var year = y.toString().substr(2, 2);
                var docprefix = "XX"
                if (this.form.DocType.value == "1") {
                    docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "22").DocPrefix;
                } else {
                    docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "23").DocPrefix;

                }

                var prefix = docprefix + userId.ShopId + year;
                GeniuzPOS.PosShift.PsTaxInvoiceHdService.GetNextNumber({
                    Prefix: prefix,
                    Length: 16
                }, response => {

                    this.form.DocNo.value = response.Serial;
                    // this.form.DocDate.element.focus();
                });
            }

        }

        private CNvatext() {

            this.form.RefTaxInvoiceAmt.getGridField().toggle(true);
            this.form.NewTaxInvoiceAmt.getGridField().toggle(true);
            this.form.TaxInvoiceAmtDiff.getGridField().toggle(true);

            this.form.NetAmt.getGridField().toggle(true);

            this.form.NetSalesNonVat.getGridField().toggle(true);
            this.form.NetSalesExVat.getGridField().toggle(true);
            this.form.NetSalesNormal.getGridField().toggle(false);
        }

        private CNvatIn() {

            this.form.RefTaxInvoiceAmt.getGridField().toggle(true);
            this.form.NewTaxInvoiceAmt.getGridField().toggle(true);
            this.form.TaxInvoiceAmtDiff.getGridField().toggle(true);

            this.form.NetAmt.getGridField().toggle(false);

            this.form.NetSalesNonVat.getGridField().toggle(true);
            this.form.NetSalesExVat.getGridField().toggle(false);
            this.form.NetSalesNormal.getGridField().toggle(true);

        }

        private TaxvatIn() {

            this.form.RefTaxInvoiceAmt.getGridField().toggle(false);
            this.form.NewTaxInvoiceAmt.getGridField().toggle(false);
            this.form.TaxInvoiceAmtDiff.getGridField().toggle(false);

            this.form.NetAmt.getGridField().toggle(false);

            this.form.NetSalesNonVat.getGridField().toggle(true);
            this.form.NetSalesExVat.getGridField().toggle(false);
            this.form.NetSalesNormal.getGridField().toggle(true);

        }

        private Taxvatext() {

            this.form.RefTaxInvoiceAmt.getGridField().toggle(false);
            this.form.NewTaxInvoiceAmt.getGridField().toggle(false);
            this.form.TaxInvoiceAmtDiff.getGridField().toggle(false);

            this.form.NetAmt.getGridField().toggle(false);

            this.form.NetSalesNonVat.getGridField().toggle(true);
            this.form.NetSalesExVat.getGridField().toggle(true);
            this.form.NetSalesNormal.getGridField().toggle(false);

        }

        private RequestfieldbyType() {
            let type = this.form.CusTaxTypeFg.value;
            if (type == "1") {
                this.form.TaxId.element.toggleClass("required", true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchName, true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchNo, true);
                this.form.TaxBranchName.value = null;
                this.form.TaxBranchNo.value = null;
                this.form.TaxPostalCode.element.toggleClass("required", true);
                this.form.TaxBranchName.element.toggleClass("required", false);
                this.form.TaxBranchNo.element.toggleClass("required", false);      
            }
            if (type == "2") {
                this.form.TaxId.element.toggleClass("required", true);
                this.form.TaxBranchName.element.toggleClass("required", true);
                this.form.TaxBranchNo.element.toggleClass("required", true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchName, false);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchNo, false);
                this.form.TaxPostalCode.element.toggleClass("required", true);
            }
            if (type == "3") {
                this.form.TaxId.element.toggleClass("required", true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchName, true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchNo, true);
                this.form.TaxBranchName.value = null;
                this.form.TaxBranchNo.value = null;
                this.form.TaxPostalCode.element.toggleClass("required", false);
                this.form.TaxBranchName.element.toggleClass("required", false);
                this.form.TaxBranchNo.element.toggleClass("required", false);

            }
            if (type == "4") {
                this.form.TaxId.element.toggleClass("required", true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchName, true);
                Serenity.EditorUtils.setReadOnly(this.form.TaxBranchNo, true);
                this.form.TaxBranchName.value = null;
                this.form.TaxBranchNo.value = null;
                this.form.TaxPostalCode.element.toggleClass("required", false);
                this.form.TaxBranchName.element.toggleClass("required", false);
                this.form.TaxBranchNo.element.toggleClass("required", false);

            }
        }


    }
}

